import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BsChevronLeft } from 'react-icons/bs';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import theme from '../../theme';
import {
  Container,
  BackArrow,
  Button,
  Title,
  Text,
  NoticeChannel,
  GroupButton,
  ButtonTitle,
  GroupContainer,
  HeaderGroups,
  FormatGroupLabel,
} from './style';
import { RootState } from '../../store';

const LINKS = {
  CANAL_DE_AVISOS: 'https://chat.whatsapp.com/IZK82RaD0wG9FvBYdf4KCi',
  GERAL: 'https://t.me/joinchat/CfueNVBmmE-xxnSgCylY9A',
  INICIANTES: 'https://t.me/joinchat/6NPVW3aDB2k3ZTRh',
  TENIS_E_VESTUARIO: 'https://t.me/joinchat/IZugLUzh0RxGul1aLSSpBQ',
  RELOGIO_E_ACESSORIOS: 'https://t.me/joinchat/IZugLUjAxweIAQbMDSMmvA',
  CENTRO_OESTE: 'https://t.me/joinchat/MCmTFRNhmzJjcDTtEsBIAQ',
  NORDESTE: 'https://t.me/joinchat/MCmTFRYaAxccHBfCJjMvaQ',
  NORTE: 'https://t.me/joinchat/MCmTFRbKe3n6PgSa2d8OBw',
  SUDESTE: 'https://t.me/joinchat/MCmTFQ8IpvfbNwAlybj4Iw',
  SUL: 'https://t.me/joinchat/MCmTFRWchvzGsKhfRKeY-w',
  BRASILIA: 'https://chat.whatsapp.com/C4BHhTtiFzNLabcjTtcuBz',
  SP: 'https://chat.whatsapp.com/Hlu6r4NTzK1F3d4qws2Bz9',
  SP_CAPITAL: 'https://chat.whatsapp.com/JEaZp0RsAcrGQkyBeaULEG',
  PORTUGAL: 'https://t.me/joinchat/IZugLUlBZ_I4FpRLQE_nPA',
  EXTERIOR: 'https://chat.whatsapp.com/HwslSTPvVMSD876wQCCgxn',
  SALVADOR: 'https://chat.whatsapp.com/DOvSaihsqsOAqSubfHEthv',
};

function formatGroupLabel(data: any) {
  return (
    <FormatGroupLabel>
      <span>{data.label}</span>
    </FormatGroupLabel>
  );
}

const customStyles = {
  control: (provided: any) => ({
    ...provided,
    width: '250px',
  }),
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: '#bdbdbd',
    overflow: 'hidden',
  }),
  option: (provided: any) => ({
    ...provided,
    textAlign: 'start',
    color: `${theme.colors.primary}`,
    backgroundColor: 'white',
  }),
};

export default function TelegramGroups({ bigger }: { bigger: boolean }) {
  const auth = useSelector((state: RootState) => state.auth);
  const { user } = auth;

  let showWhatsAppFemale = false;

  if (user.genre && (user.genre.toUpperCase() === 'FEM' || user.genre.toUpperCase() === 'FEMININO' || user.genre.toUpperCase() === 'F')) {
    showWhatsAppFemale = true;
  }

  const navigate = useNavigate();
  const goToBack = () => {
    navigate('/club');
  };
  const [selectedGroup, setSelectedGroup] = useState('');

  const handleGroupSelect = (selectedOption: any) => {
    setSelectedGroup(selectedOption.value);
  };

  const handleGroupButtonClick = (link: any) => {
    window.location.href = link;
  };

  const links: any = [
    {
      name: 'Estado - São Paulo',
      type: 'Estado',
      buttons: [
        {
          name: 'Canal de avisos',
          link: 'https://chat.whatsapp.com/EFfWY5yfO5R49J3OWCW8dz',
        },
        {
          name: 'São Paulo',
          link: LINKS.SP,
        },
      ],
    },
    {
      name: 'São Paulo - Capital e Região',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'São Paulo - Capital e Região',
          link: LINKS.SP_CAPITAL,
        },
      ],
    },
    {
      name: 'São Paulo - Baixada Santista',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Baixada Santista',
          link: 'https://chat.whatsapp.com/Fr1o2bbT34JIobth1YQDgj',
        },
      ],
    },
    {
      name: 'São Paulo - SJC e Região',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'São José dos Campos',
          link: 'https://chat.whatsapp.com/CMgGR0pNl5oJkKCsnzXD9f',
        },
      ],
    },
    {
      name: 'São Paulo - Campinas e Região',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Campinas',
          link: 'https://chat.whatsapp.com/DAktAf0gUeA8NQBviHhzYl',
        },
      ],
    },

    {
      name: 'Estado - Rio de Janeiro',
      type: 'Estado',
      buttons: [
        {
          name: 'Estado - Rio de Janeiro',
          link: 'https://chat.whatsapp.com/BF1S06pAj4DDJhyd1U0OLV',
        },
      ],
    },
    {
      name: 'Rio de Janeiro - Capital e Região',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Rio de Janeiro (capital e região)',
          link: 'https://chat.whatsapp.com/DU34iekEEp0A1YGwcQY0LO',
        },
      ],
    },
    {
      name: 'Estado - Espiríto Santo',
      type: 'Estado',
      buttons: [
        {
          name: 'Espírito Santo',
          link: 'https://chat.whatsapp.com/LOQpgjqZQSlDu5K1V5In3b',
        },
      ],
    },
    {
      name: 'Estado - Minas Gerais',
      type: 'Estado',
      buttons: [
        {
          name: 'Minas Gerais',
          link: 'https://chat.whatsapp.com/LmIpqUcvKyVCUmbfwZW0rN',
        },
      ],
    }, {
      name: 'Belo Horizonte',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Belo Horizonte',
          link: 'https://chat.whatsapp.com/JyWmjytnUpOAoGeH68Ie1z',
        },
      ],
    },
    {
      name: 'Estado - Paraná',
      type: 'Estado',
      buttons: [
        {
          name: 'Paraná',
          link: 'https://chat.whatsapp.com/FXlFu7Zd47mJlJPE9CwDvY',
        },
      ],
    },
    {
      name: 'Paraná - Curitiba',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Curitiba',
          link: 'https://chat.whatsapp.com/HeP9ACLO2lSBmQla1JOEZc',
        },
      ],
    },
    {
      name: 'Estado - Rio Grande do Sul',
      type: 'Estado',
      buttons: [
        {
          name: 'Rio Grande do Sul',
          link: 'https://chat.whatsapp.com/JA2Nh0gseEM4DDKoREAAbD',
        },
      ],
    },
    {
      name: 'Rio Grande do Sul - Porto Alegre',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Porto Alegre',
          link: 'https://chat.whatsapp.com/EUB4ZSKkdjNCNe5ExopqzD',
        },
      ],
    },
    {
      name: 'Estado - Santa Catarina',
      type: 'Estado',
      buttons: [
        {
          name: 'Santa Catarina',
          link: 'https://chat.whatsapp.com/H5thZwvOEtuKgGlXut44AI',
        },
      ],
    },
    {
      name: 'Santa Catarina - Floripa e Região',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Floripa',
          link: 'https://chat.whatsapp.com/KVSGz1UjtopAGmMYAqvwgA',
        },
      ],
    },
    {
      name: 'Estado - Brasília DF',
      type: 'Estado',
      buttons: [
        {
          name: 'Canal de avisos',
          link: 'https://chat.whatsapp.com/DA5pDsx66BnE6yU2ylarNP',
        },
        {
          name: 'Brasília',
          link: LINKS.BRASILIA,
        },
      ],
    },
    {
      name: 'Estado - Goiás',
      type: 'Estado',
      buttons: [
        {
          name: 'Goiás',
          link: 'https://chat.whatsapp.com/HwuPUuIZ5mNBJeRuBYOa2P',
        },
      ],
    },
    {
      name: 'Goiás - Goiânia',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Goiânia e Região',
          link: 'https://chat.whatsapp.com/CgFnUg3HIUPGqA31BZA9gw',
        },
      ],
    },
    {
      name: 'Estado - Mato Grosso',
      type: 'Estado',
      buttons: [
        {
          name: 'Mato Grosso',
          link: 'https://chat.whatsapp.com/BLdPBvq8eKIAnWIM62xmBz',
        },
      ],
    },
    {
      name: 'Estado - Mato Grosso do Sul',
      type: 'Estado',
      buttons: [
        {
          name: 'Mato Grosso do Sul',
          link: 'https://chat.whatsapp.com/KUbMlwheLHU9cG5MGGGN7v',
        },
      ],
    },
    {
      name: 'Estado - Bahia',
      type: 'Estado',
      buttons: [
        {
          name: 'Bahia',
          link: 'https://chat.whatsapp.com/EX2NxiRB2P6G1bkcF2WW7y',
        },
      ],

    },
    {
      name: 'Bahia - Salvador',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Salvador',
          link: LINKS.SALVADOR,
        },
      ],
    },
    {
      name: 'Estado - Ceará',
      type: 'Estado',
      buttons: [
        {
          name: 'Ceará',
          link: 'https://chat.whatsapp.com/DawRMx2YHxK2nRvEzd7qas',
        },
      ],
    },
    {
      name: 'Ceará - Fortaleza',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Fortaleza',
          link: 'https://chat.whatsapp.com/L3qrtQkTzaABANXHBFqN4u',
        },
      ],
    },
    {
      name: 'Estado - Pernambuco',
      type: 'Estado',
      buttons: [
        {
          name: 'Pernambuco',
          link: 'https://chat.whatsapp.com/ENbiyfIiOJwJsZWhKLPwxq',
        },
      ],
    },
    {
      name: 'Pernambuco - Recife',
      type: 'CidadeRegiao',
      buttons: [
        {
          name: 'Recife',
          link: 'https://chat.whatsapp.com/HbhOKkrwSt42aRebVgC1mN',
        },
      ],
    },
    {
      name: 'Estado - Paraíba',
      type: 'Estado',
      buttons: [
        {
          name: 'Paraíba',
          link: 'https://chat.whatsapp.com/HgIvqDVpMIvGo7lcdvsgux',
        },
      ],
    },
    {
      name: 'Estado - Rio Grande do Norte',
      type: 'Estado',
      buttons: [
        {
          name: 'Rio Grande do Norte',
          link: 'https://chat.whatsapp.com/KSufJubMkFA1MvlvrGO6nZ',
        },
      ],
    },
    {
      name: 'Estado - Piauí',
      type: 'Estado',
      buttons: [
        {
          name: 'Piauí',
          link: 'https://chat.whatsapp.com/JzjUhCylQL456KTE1yQY18',
        },
      ],
    },
    {
      name: 'Estado - Sergipe',
      type: 'Estado',
      buttons: [
        {
          name: 'Sergipe',
          link: 'https://chat.whatsapp.com/GDiGRlC4XMz6MlT4G7rM3L',
        },
      ],
    },
    {
      name: 'Estado - Alagoas',
      type: 'Estado',
      buttons: [
        {
          name: 'Alagoas',
          link: 'https://chat.whatsapp.com/BvK0SQqfP9uLa3vNA0xjMT',
        },
      ],
    },
    {
      name: 'Estado - Maranhão',
      type: 'Estado',
      buttons: [
        {
          name: 'Maranhão',
          link: 'https://chat.whatsapp.com/HJutvu0iIaN3fVhznndvjP',
        },
      ],
    },
    {
      name: 'Estado - Amazonas',
      type: 'Estado',
      buttons: [
        {
          name: 'Amazonas',
          link: 'https://chat.whatsapp.com/HEogTyoKxr63DaUxnWcGvR',
        },
      ],
    },
    {
      name: 'Estado - Tocantins',
      type: 'Estado',
      buttons: [
        {
          name: 'Tocantins',
          link: 'https://chat.whatsapp.com/JomW6dtV3iE85hJRBwMTov',
        },
      ],
    },
    {
      name: 'Estado - Rondônia',
      type: 'Estado',
      buttons: [
        {
          name: 'Rondônia',
          link: 'https://chat.whatsapp.com/KgLRatSd6NUInW07MUotgV',
        },
      ],
    },
    {
      name: 'Estado - Roraima',
      type: 'Estado',
      buttons: [
        {
          name: 'Roraima',
          link: 'https://chat.whatsapp.com/D03P6iXgLo5EsiR7O62IsR',
        },
      ],
    },
    {
      name: 'Estado - Acre',
      type: 'Estado',
      buttons: [
        {
          name: 'Acre',
          link: 'https://chat.whatsapp.com/F4rodbDKsR9AiaQqP0OPfc',
        },
      ],
    },
    {
      name: 'Estado - Pará',
      type: 'Estado',
      buttons: [
        {
          name: 'Pará',
          link: 'https://chat.whatsapp.com/L0UeBF9U88M3vLziSE2HpE',
        },
      ],
    },
    {
      name: 'Amapá',
      type: 'Estado',
      buttons: [
        {
          name: 'Amapá',
          link: 'https://chat.whatsapp.com/GRIqTNrZES6Ds00tLKd9c5',
        },
      ],
    },
  ].sort((n1, n2) => {
    if (n1.name > n2.name) {
      return 1;
    }

    if (n1.name < n2.name) {
      return -1;
    }

    return 0;
  });

  const groupData: { name: string, type: 'Estado' | 'CidadeRegiao', buttons: { name: string, link: string }[] }[] = links;

  const marathonData = [
    {
      name: 'Majors',
      buttons: [
        {
          name: 'Majors',
          link: 'https://chat.whatsapp.com/FkrXPPi8nMp702aHhvXfrP',
        },
      ],
    },
    {
      name: 'Maratona de São Paulo',
      buttons: [
        {
          name: 'Maratona Int’l de São Paulo',
          link: 'https://chat.whatsapp.com/CKJsDb8aLBgJgDltcsC44q',
        },
      ],
    },
    {
      name: 'SP City',
      buttons: [
        {
          name: 'SP City',
          link: 'https://chat.whatsapp.com/FEpTk52GE1Q8u9rZhSndmH',
        },
      ],
    },
    {
      name: 'Maratona Monumental BSB',
      buttons: [
        {
          name: 'Maratona Monumental BSB',
          link: 'https://chat.whatsapp.com/HZ9QgJ55JNdH9OsXO4idTB',
        },
      ],
    },
    {
      name: 'New Balance 42k Porto Alegre',
      buttons: [
        {
          name: 'New Balance 42k Porto Alegre',
          link: 'https://chat.whatsapp.com/Bevy2LJewRMIlhtSvq969q',
        },
      ],
    },
    {
      name: 'Maratona do Rio',
      buttons: [
        {
          name: 'Maratona do Rio',
          link: 'https://chat.whatsapp.com/CyaUbSeFlarLerHkiRBQQQ',
        },
      ],
    },
    {
      name: 'Maratona de Porto Alegre',
      buttons: [
        {
          name: 'Maratona de Porto Alegre',
          link: 'https://chat.whatsapp.com/E2ZXeUYREvU9fHIhpAzSDb',
        },
      ],
    },
    {
      name: 'Meia Int\'l do Rio de Janeiro',
      buttons: [
        {
          name: 'Meia Int\'l do Rio de Janeiro',
          link: 'https://chat.whatsapp.com/LC1EMOGGRRI1pOM6yIgHdq',
        },
      ],
    },
    {
      name: 'Maratona Int\'l de Floripa',
      buttons: [
        {
          name: 'Maratona Int\'l de Floripa',
          link: 'https://chat.whatsapp.com/GgCsg39uHyF1hK60ak8L5I',
        },
      ],
    },
    {
      name: 'Meia do Sol (Natal/RN)',
      buttons: [
        {
          name: 'Meia do Sol (Natal/RN)',
          link: 'https://chat.whatsapp.com/CRem1yQiDQi2TwtkDjZEMT',
        },
      ],
    },
    {
      name: '10 Milhas Garoto (Vitória/ES)',
      buttons: [
        {
          name: '10 Milhas Garoto (Vitória/ES)',
          link: 'https://chat.whatsapp.com/I1KaKTuOrge34wWD0u12Vq',
        },
      ],
    },
    {
      name: 'Meia de Sampa',
      buttons: [
        {
          name: 'Meia de Sampa',
          link: 'https://chat.whatsapp.com/I2x8gwQB0zj2UodHVSsdN6',
        },
      ],
    },
    {
      name: 'Volta da Pampulha',
      buttons: [
        {
          name: 'Volta da Pampulha',
          link: 'https://chat.whatsapp.com/D2gbJeHNGt88FNcBiGM6vH',
        },
      ],
    },
    {
      name: 'São Silvestre',
      buttons: [
        {
          name: 'São Silvestre',
          link: 'https://chat.whatsapp.com/FfSkN8pPw4xAfsBMzAcNWr',
        },
      ],
    },
  ];

  groupData.map((group) => ({
    value: group.name,
    label: group.name,
  }));

  const selectedGroupData = groupData.filter((group) => selectedGroup === '' ? false : group.name.includes(selectedGroup)); // eslint-disable-line

  const dropdownOptions = [
    {
      label: 'Selecione',
      options: groupData.map(({ name }) => ({ value: name, label: name })),
    },
  ];

  const selectedMarathonData = marathonData.find((group) => group.name === selectedGroup);

  const dropdownMarathonOptions = marathonData.map((group) => ({
    value: group.name,
    label: group.name,
  }));

  const distanceData = [
    {
      name: '5 e 10km',
      buttons: [
        {
          name: '5 e 10km',
          link: 'https://chat.whatsapp.com/G9aIfgzSO6HEGsJiK0y1HU',
        },
      ],
    },
    {
      name: '21km',
      buttons: [
        {
          name: '21km',
          link: 'https://chat.whatsapp.com/GvUny7jArl8EAvlLgXmJlJ',
        },
      ],
    },

    {
      name: '42km',
      buttons: [
        {
          name: '42km',
          link: 'https://chat.whatsapp.com/Fuzoq6S6awv6BLLUvyzu9B',
        },
      ],
    },

    {
      name: 'Trail',
      buttons: [
        {
          name: 'Trail',
          link: 'https://chat.whatsapp.com/LMMLoEivR1TASe8yHWWUfA',
        },
      ],
    },
  ];

  if (showWhatsAppFemale) {
    distanceData.push({
      name: 'CP Mulheres ',
      buttons: [
        {
          name: 'CP Mulheres ',
          link: 'https://chat.whatsapp.com/JPigHTiEJ6FLB46RPFVd5V',
        },
      ],
    });
  }
  const selectedDistanceData = distanceData.find((group) => group.name === selectedGroup);

  const dropdownDistanceOptions = distanceData.map((group) => ({
    value: group.name,
    label: group.name,
  }));

  return (
    <Container>
      <BackArrow>
        <Button type="button" onClick={goToBack}>
          <BsChevronLeft color="#FFFFFF" size={bigger ? 24 : 22} />
        </Button>
        <Title onClick={goToBack}>grupos no Whatsapp</Title>
      </BackArrow>
      <Text>
        Nossas comunidades de clientes estão reunidos em grupos regionais no WhatsApp. Esses grupos se destinam exclusivamente à interação saudável, amistosa e agregador entre os membros do Corrida Perfeita.
      </Text>
      <Text>
        Faça parte do grupo geral de avisos da comunidade e do seu grupo regional. Apresente-se ao entrar.
      </Text>

      <NoticeChannel>
        <h5>Canal de Avisos</h5>
        <p>
          No nosso Canal de Avisos, onde somente a Equipe CP encaminha mensagens.
          Caso você não se interesse por nenhum grupo, recomendamos que ingresse ao menos neste
          Canal de Avisos, pois é o local em que postaremos comunicados de interesse geral de todos os alunos.
        </p>

        <GroupButton
          type="button"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = LINKS.CANAL_DE_AVISOS;
          }}
        >
          <ButtonTitle>entrar</ButtonTitle>
        </GroupButton>
      </NoticeChannel>

      <GroupContainer>
        <HeaderGroups>
          <h5>Grupos Locais</h5>
        </HeaderGroups>
        <Text>
          Digite seu Estado, Cidade ou Região
        </Text>
        <br />
        <div>
          <Select
            options={dropdownOptions}
            onChange={handleGroupSelect}
            placeholder="Digite para buscar..."
            isSearchable
            isClearable
            noOptionsMessage={({ inputValue }) => !inputValue ? '' : 'Não há nenhum grupo'} // eslint-disable-line
            styles={customStyles}
            formatGroupLabel={formatGroupLabel}
          />
          <br />
          {selectedGroupData && (
            <div>
              {selectedGroupData.map((select) => (
                select.buttons.map((button, index) => (
                  <GroupButton
                    key={index}
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleGroupButtonClick(button.link);
                    }}
                  >
                    <ButtonTitle>{button.name}</ButtonTitle>
                  </GroupButton>
                ))))}
            </div>
          )}
        </div>
      </GroupContainer>

      <GroupContainer>
        <HeaderGroups>
          <h5>Exterior</h5>
        </HeaderGroups>
        <br />

        <GroupButton
          type="button"
          onClick={(e) => {
            e.preventDefault();
            window.location.href = LINKS.EXTERIOR;
          }}
        >
          <ButtonTitle>Residentes no Exterior</ButtonTitle>
        </GroupButton>
      </GroupContainer>

      <GroupContainer>
        <NoticeChannel>
          <HeaderGroups>
            <h5>Provas e Eventos de Corrida</h5>
          </HeaderGroups>
          <p>
            Aqui temos os grupos para reunir nossos membros e falar da nossa presença e apoio nas provas de maior participação nacional. Para provas locais, as informações serão tratadas nos grupos da respectiva região.
          </p>

        </NoticeChannel>
        <Text>
          Digite o nome da prova
        </Text>
        <br />
        <div>
          <Select
            options={dropdownMarathonOptions}
            onChange={handleGroupSelect}
            placeholder="Digite para buscar..."
            isSearchable
            isClearable
            noOptionsMessage={({ inputValue }) => !inputValue ? '' : 'Não há nenhum grupo'} // eslint-disable-line
            styles={
              {
                control: (provided: any) => ({
                  ...provided,
                  width: '250px',
                }),
                menu: (provided: any) => ({
                  ...provided,
                  backgroundColor: 'white',
                  overflow: 'hidden',
                }),
                option: (provided: any) => ({
                  ...provided,
                  textAlign: 'start',
                  color: `${theme.colors.primary}`,
                  backgroundColor: 'white',
                }),
              }
            }

          />
          <br />
          {selectedMarathonData && (
            <div>
              {selectedMarathonData.buttons.map((button, index) => (
                <GroupButton
                  key={index}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    handleGroupButtonClick(button.link);
                  }}
                >
                  <ButtonTitle>{button.name}</ButtonTitle>
                </GroupButton>
              ))}
            </div>
          )}
        </div>

      </GroupContainer>

      <GroupContainer>
        <NoticeChannel>
          <HeaderGroups>
            <h5>Temáticos</h5>
          </HeaderGroups>
          <p>
            Aqui temos grupos para interação geral dos atletas segundo seus objetivos de corrida e outros assuntos do universo dos corredores.
          </p>

        </NoticeChannel>
        <Text>
          Digite o tema
        </Text>
        <br />
        <div>
          <Select
            options={dropdownDistanceOptions}
            onChange={handleGroupSelect}
            placeholder="Digite para buscar..."
            isSearchable
            isClearable
            noOptionsMessage={({ inputValue }) => !inputValue ? '' : 'Não há nenhum grupo'} // eslint-disable-line
            styles={
              {
                control: (provided: any) => ({
                  ...provided,
                  width: '250px',
                }),
                menu: (provided: any) => ({
                  ...provided,
                  backgroundColor: 'white',
                  overflow: 'hidden',
                }),
                option: (provided: any) => ({
                  ...provided,
                  textAlign: 'start',
                  color: `${theme.colors.primary}`,
                  backgroundColor: 'white',
                }),
              }
            }

          />
          <br />
          {selectedDistanceData && (
            <div>
              {selectedDistanceData.buttons.map((button, index) => (
                <GroupButton
                  key={index}
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    handleGroupButtonClick(button.link);
                  }}
                >
                  <ButtonTitle>{button.name}</ButtonTitle>
                </GroupButton>
              ))}
            </div>
          )}
        </div>

      </GroupContainer>

    </Container>
  );
}
